function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  fill: "#FFFFFF",
  d: "M242.6,484.8c-61.9,0-124-23.6-171.1-70.8C25.8,368.2,0.6,307.5,0.6,242.8S25.8,117.2,71.5,71.6 c94.5-94.3,248-94.3,342.4,0l0,0c94.3,94.6,94.3,248.3,0,342.5C366.7,461.3,304.6,484.8,242.6,484.8z"
}), React.createElement("g", {
  id: "_x30_3_00000082370447201951024060000005849943563062710950_"
}, React.createElement("path", {
  fill: "#162340",
  d: "M410.5,410.8c-92.8,92.7-243.1,92.7-335.9,0c-92.7-92.7-92.7-243.1,0-335.9c92.7-92.7,243.1-92.7,335.9,0 C503.2,167.7,503.2,318,410.5,410.8z"
})), React.createElement("g", {
  id: "_x30_3_00000133527673629795856160000015588659786992935615_"
}, React.createElement("path", {
  fill: "#FFFFFF",
  d: "M413.7,243.6c0,95.8-77.7,173.5-173.5,173.5c-95.8,0-173.5-77.7-173.5-173.5c0-95.8,77.7-173.5,173.5-173.5 C336,70.2,413.7,147.8,413.7,243.6z"
})), React.createElement("g", {
  id: "_x30_3_00000112621664032845543170000010001557490841463991_"
}, React.createElement("path", {
  fill: "#162340",
  d: "M240.2,411.3c-92.5,0-167.7-75.2-167.7-167.7C72.5,151.2,147.7,76,240.2,76c92.5,0,167.7,75.2,167.7,167.7 C407.9,336.1,332.6,411.3,240.2,411.3z M240.2,81c-89.7,0-162.7,73-162.7,162.7c0,89.7,73,162.7,162.7,162.7s162.7-73,162.7-162.7 C402.9,153.9,329.9,81,240.2,81z"
})), React.createElement("g", null, React.createElement("path", {
  fill: "#FFFFFF",
  d: "M34.5,319.2l-2.2-7.5l19.5-14.4l-24.2-1.9l-2.1-7.4l34.8,3.6l1.7,6L34.5,319.2z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M24.2,279.1l-2.7-24.2l6.3-0.7l1.9,17.2l6.5-0.7l-1.7-15.1l6.3-0.7l1.7,15.1l6.7-0.8l-1.9-17.4l6.3-0.7 l2.7,24.4L24.2,279.1z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M21.1,244.2l0.4-7.1l12.7,0.7l0.7-13.1l-12.7-0.7l0.4-7.1l32.2,1.7l-0.4,7.1l-12.9-0.7l-0.7,13.1l12.9,0.7 l-0.4,7.1L21.1,244.2z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M24.5,205.9l1.3-7l31.7,5.9l-1.3,7L24.5,205.9z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M43,194.2L43,194.2c-8.8-2.8-13.9-11.7-10.9-21.1c1.9-5.8,4.9-8.6,8.6-10.6l3.6,5.9c-2.9,1.7-5,3.7-6,6.8 c-1.7,5.2,1.5,10.3,6.7,12l0.1,0c5.3,1.7,10.8-0.6,12.5-5.8c1.1-3.5,0.4-6.1-1-9.2l5.7-2.9c2.4,4.2,3.4,8.4,1.5,14.3 C60.9,192.6,51.8,197.1,43,194.2z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M40.6,152.2l3.2-6.3l23,11.7l7.3-14.3l5.8,2.9l-10.5,20.7L40.6,152.2z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M55.9,123.8L70,104l5.1,3.7l-10,14.1l5.3,3.8l8.8-12.4l5.1,3.7l-8.8,12.4l5.5,3.9l10.2-14.2l5.1,3.7l-14.3,20 L55.9,123.8z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M97.1,97.8L97.1,97.8c-6.1-7-5.8-17.2,1.7-23.7c4.6-4,8.7-4.9,12.9-4.6l0,6.9c-3.4-0.1-6.2,0.6-8.6,2.7 c-4.1,3.6-4.1,9.5-0.5,13.7l0.1,0.1c3.6,4.2,9.5,5.1,13.7,1.5c2.8-2.4,3.5-5,3.9-8.4l6.4,0.5c-0.2,4.9-1.5,8.9-6.2,13 C113.3,105.7,103.2,104.8,97.1,97.8z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M123.4,75.3L123.4,75.3c-4.7-8-2.3-18.1,6.2-23.2c8.6-5.1,18.5-2.3,23.2,5.6l0,0.1c4.7,7.9,2.3,18-6.3,23.1 C138,85.9,128.1,83.1,123.4,75.3z M146.6,61.5L146.6,61.5c-2.9-4.8-8.7-6.7-13.6-3.8c-4.9,2.9-6,8.8-3.2,13.6l0,0.1 c2.8,4.8,8.7,6.7,13.6,3.7C148.3,72.2,149.4,66.3,146.6,61.5z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M155,39.1l7.2-2.5l12.5,10.1l3.6-15.7l7.2-2.5L196,59.1l-6.7,2.3l-6.9-19.9l-4.1,16l-0.2,0.1l-13-10l6.8,19.8 l-6.6,2.3L155,39.1z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M197.5,26.1l13-2c7.6-1.2,12.9,2.6,13.9,9.2l0,0.1c1.1,7.4-4,12.1-11.2,13.2l-5.3,0.8l1.5,9.6l-7,1.1 L197.5,26.1z M212.5,40.2c3.5-0.5,5.2-2.9,4.8-5.7l0-0.1c-0.5-3.1-2.9-4.5-6.4-4l-5.4,0.8l1.5,9.7L212.5,40.2z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M231.1,21.9l7.1-0.1l0.4,25.8l16.1-0.2l0.1,6.5l-23.2,0.3L231.1,21.9z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M263.2,22.7l7.1,0.8l-3.5,32.1l-7.1-0.8L263.2,22.7z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M292.3,27.2l6.4,1.6l5.7,34.8l-7.2-1.8l-1.1-7.7l-13.2-3.3l-4.6,6.3l-7-1.7L292.3,27.2z M295,47.4l-1.7-11.2 l-6.7,9.1L295,47.4z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M321,35.7l6,2.7l5.5,24.3l8.2-18.1l6.4,2.9l-13.4,29.3l-5.5-2.5l-5.7-25.1L314,67.9l-6.4-2.9L321,35.7z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M347.2,66.2L347.2,66.2c5.3-7.6,15.3-9.8,23.4-4.2c5,3.5,6.8,7.2,7.6,11.3l-6.7,1.7c-0.8-3.3-2-5.9-4.7-7.7 c-4.5-3.1-10.3-1.6-13.4,2.9l-0.1,0.1c-3.2,4.5-2.6,10.5,1.9,13.7c3,2.1,5.7,2.2,9.1,1.7l1.1,6.3c-4.8,1-9,0.7-14.2-2.8 C343.5,83.8,341.9,73.8,347.2,66.2z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M388.2,76.3l17.4,17l-4.4,4.5l-12.4-12.1l-4.6,4.7l10.9,10.6l-4.4,4.5l-10.9-10.6l-4.7,4.9l12.6,12.2 l-4.4,4.5l-17.6-17.1L388.2,76.3z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M397.6,126.5l6.5,0.8c-0.4,3.7,0,7.1,2,10.2c1.6,2.4,3.5,3.3,5.1,2.2l0.1,0c1.5-1,1.7-2.4-0.1-7.7 c-2.1-6.4-2.9-10.8,2.4-14.3l0.1,0c4.9-3.2,10.7-1.4,14.3,4.2c2.6,3.9,3.5,8.1,3.1,12.3l-6.5-0.2c0.1-3.5-0.4-6.5-1.9-8.8 s-3.3-2.8-4.6-1.9l-0.1,0c-1.8,1.2-1.6,2.7,0.2,8.1c2.1,6.4,2.2,10.8-2.5,13.9l-0.1,0c-5.4,3.5-11,1.4-14.8-4.5 C398.1,136.7,396.8,131.6,397.6,126.5z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M424.1,147L424.1,147c8.5-3.7,18.1-0.4,22.1,8.6c2.5,5.6,2.1,9.7,0.6,13.6l-6.6-2c1.1-3.2,1.3-6.1,0-9 c-2.2-5-7.9-6.7-13-4.5l-0.1,0c-5.1,2.2-7.7,7.6-5.5,12.6c1.5,3.4,3.7,4.8,6.9,6.2l-2.4,6c-4.6-1.6-8.1-4.1-10.6-9.8 C411.8,160.2,415.6,150.8,424.1,147z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M454,177.3l1.7,6.9l-12.4,3l3.1,12.7l12.4-3l1.7,6.9l-31.3,7.6l-1.7-6.9l12.6-3l-3.1-12.7l-12.6,3l-1.7-6.9 L454,177.3z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M462.1,215.6l1.7,24.3l-6.3,0.4l-1.2-17.2l-6.5,0.5l1.1,15.2l-6.3,0.4l-1.1-15.2l-6.8,0.5l1.2,17.5l-6.3,0.4 l-1.7-24.5L462.1,215.6z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M463.9,250.9l-0.8,7.6l-14.5,7l12.6,9.9l-0.8,7.6l-32.1-3.5l0.8-7l20.9,2.3l-12.7-10.5l0-0.2l14.5-7.5 l-20.8-2.3l0.8-6.9L463.9,250.9z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M457.6,294.8l-6.9,23.3l-6-1.8l4.9-16.6l-6.3-1.9l-4.3,14.6l-6-1.8l4.3-14.6l-6.5-1.9l-5,16.8l-6-1.8l7-23.5 L457.6,294.8z"
})), React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  fill: "#162340",
  d: "M104.1,243.8v-0.2c0-18.8,14.4-33.5,33.9-33.5c13.2,0,21.6,5.5,27.4,13.4l-13.4,10.4 c-3.7-4.5-7.9-7.6-14.1-7.6c-9,0-15.4,7.7-15.4,17.1v0.2c0,9.7,6.4,17.2,15.4,17.2c6.7,0,10.7-3.1,14.6-7.8l13.4,9.6 c-6.1,8.4-14.3,14.6-28.5,14.6C119,277.2,104.1,263.1,104.1,243.8L104.1,243.8z"
}), React.createElement("polygon", {
  fill: "#162340",
  points: "171.1,211.2 189.4,211.2 189.4,235.5 212.5,235.5 212.5,211.2 230.4,211.2 230.4,276.1 212.5,276.1 212.5,251.4 189,251.4 189,276.1 171.1,276.1 171.1,211.2  "
}), React.createElement("polygon", {
  fill: "#162340",
  points: "171.1,211.2 189.4,211.2 189.4,235.5 212.5,235.5 212.5,211.2 230.4,211.2 230.4,276.1 212.5,276.1 212.5,251.4 189,251.4 189,276.1 171.1,276.1 171.1,211.2  "
}), React.createElement("path", {
  fill: "#162340",
  d: "M308.1,266.5l9.9-11.9c6.4,5.1,13.4,7.7,20.9,7.7c4.9,0,7.4-1.7,7.4-4.4v-0.3c0-2.8-2.1-4.2-11-6.3 c-13.8-3.1-24.4-7-24.4-20.3v-0.4c0-11.9,9.4-20.5,24.8-20.5c10.9,0,19.4,2.9,26.3,8.5l-8.9,12.5c-5.9-4.2-12.3-6.3-17.9-6.3 c-4.3,0-6.4,1.7-6.4,4.1v0.3c0,3,2.2,4.3,11.3,6.3c14.9,3.2,24.1,8.1,24.1,20.2v0.3c0,13.1-10.4,21-26,21 C326.9,277.2,316.1,273.6,308.1,266.5L308.1,266.5z"
}), React.createElement("path", {
  fill: "#162340",
  d: "M359.9,232.1L359.9,232.1c0-4.5,3.6-8.3,8.2-8.3c4.6,0,8.2,3.7,8.2,8.2v0c0,4.5-3.6,8.2-8.2,8.2 C363.5,240.3,359.9,236.6,359.9,232.1L359.9,232.1z M374.3,232L374.3,232c0-3.4-2.6-6.3-6.2-6.3c-3.5,0-6.2,2.8-6.2,6.3v0 c0,3.4,2.6,6.2,6.2,6.2C371.6,238.3,374.3,235.5,374.3,232L374.3,232z M364.7,227.9h3.7c2,0,3.4,0.9,3.4,2.6c0,1.2-0.6,2-1.6,2.4 l1.8,2.6h-3l-1.4-2h-0.6v2h-2.4V227.9L364.7,227.9z M368.2,231.5c0.7,0,1-0.3,1-0.8c0-0.5-0.4-0.8-1-0.8h-1.2v1.6H368.2 L368.2,231.5z"
}), React.createElement("path", {
  fill: "#162340",
  d: "M235,276.1h19l4.6-11.6h24.8l4.6,11.6h19.5l-27.4-64.9h-17.7L235,276.1L235,276.1z M278.3,250.3h-14.6 l7.3-18.4L278.3,250.3L278.3,250.3z"
}))));

var SvgChasvcs = function SvgChasvcs(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "CHAS_VCS",
    x: "0px",
    y: "0px",
    viewBox: "0 0 485 485.3",
    style: {
      enableBackground: "new 0 0 485 485.3"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgChasvcs, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/CHAS VCS.a91501d2.svg";
export { ForwardRef as ReactComponent };